<template>
  <td
    class="document-status-cell"
    :data-status="status"
    :style="{
      color,
    }"
  >
    <template v-if="analyse">
      <span v-if="status === 'exist'" class="document-status-cell__wrapper">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 6L7 8C7 8 10.3284 4.67157 11.5 3.5M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>

      <span v-else-if="status === 'required'" class="document-status-cell__wrapper">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 7H9M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>

      <span v-else-if="status === 'expiring'" class="document-status-cell__wrapper">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="date">{{ expirationDate }}</span>
      </span>

      <span v-else-if="status === 'expired'" class="document-status-cell__wrapper">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 5L9 9M9 5L5 9M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="date">{{ expirationDate }}</span>
      </span>
    </template>
  </td>
</template>

<script>
export default {
  name: "medical-analyse-status-cell",
  props: ["worker", "analyseId", "groupId"],

  computed: {
    analyse() {
      const group = this.worker.analyseGroups.find((g) => +g.id === this.groupId);
      if (!group) return {};
      return group.analyses.find((d) => +d.id === this.analyseId);
    },
    status() {
      return this.analyse && this.analyse.status;
    },
    color() {
      switch (this.status) {
        case "exist":
          return "#12C971";
        case "required":
          return "#FF0000";
        case "expiring":
          return "#FFB800";
        case "expired":
          return "#FF238D";
        default:
          return "";
      }
    },
    expirationDate() {
      const { expirationDate, daysLeft } = this.analyse.expireInfo;

      return `${expirationDate}, ${daysLeft} дн.`;
    },
  },
};
</script>
<style lang="scss" scoped>
.document-status-cell {
  position: relative;
  z-index: 1;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.2;
  }

  &[data-status="required"],
  &[data-status="expiring"],
  &[data-status="expired"] {
    &:before {
      background-color: currentColor;
    }
  }

  &__wrapper {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  svg {
    color: currentColor;
  }

  .date {
    color: #000000;
    margin-left: 10px;
    font-size: 13px;
  }
}
</style>
